export default {"src":"/_next/static/media/arrow_down_white.9ba40445.svg","height":5,"width":8,"blurWidth":0,"blurHeight":0};